module.exports = __webpack_public_path__ + "img/uob.1d0b6d45.svg";